import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, CheckIcon, ShieldIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ColorComparisonPage() {
  return <div className="w-full bg-[#f8f8f8]" data-id="element-658">
      {/* Back button */}
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-659">
        <Link to="/" className="flex items-center text-gray-600 hover:text-[#214ae9] transition-colors font-medium" data-id="element-660">
          <ArrowLeftIcon size={20} className="mr-2" data-id="element-661" />
          <span data-id="element-662">Go Back</span>
        </Link>
      </div>

      <div className="max-w-7xl mx-auto px-6 pb-16" data-id="element-663">
        <div className="text-center mb-12" data-id="element-664">
          <h1 className="text-4xl md:text-5xl font-bold text-[#111111] mb-4" data-id="element-665">
            Color Strategy Options
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-666">
            Explore different approaches to using your brand colors. Each option
            shows a unique hierarchy and emphasis.
          </p>
        </div>

        <div className="space-y-16" data-id="element-667">
          {/* Option 1: Blue Primary (Current) */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-668">
            <div className="bg-[#1a0647] px-8 py-4 border-b border-gray-700" data-id="element-669">
              <h2 className="text-xl font-bold text-white" data-id="element-670">
                Option 1: Blue Primary
              </h2>
              <p className="text-sm text-gray-300" data-id="element-671">
                Professional and trustworthy • Current implementation
              </p>
            </div>
            <div className="p-8" data-id="element-672">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-673">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-674">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-675">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-676">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-677">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-678">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-lg flex items-center space-x-2" data-id="element-679">
                      <span data-id="element-680">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-681" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-682">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-683">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-684">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-685">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-686" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-687">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-688">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-689">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-690">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-691" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-692">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-693">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 2: Purple Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-694">
            <div className="bg-[#b063ff] px-8 py-4 border-b border-purple-400" data-id="element-695">
              <h2 className="text-xl font-bold text-white" data-id="element-696">
                Option 2: Purple Primary
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-697">
                Modern and energetic • Bold personality
              </p>
            </div>
            <div className="p-8" data-id="element-698">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-699">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-700">
                  <div className="inline-block bg-[#00f4f8] bg-opacity-20 text-[#00f4f8] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#00f4f8] border-opacity-30" data-id="element-701">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-702">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-703">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-704">
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg flex items-center space-x-2" data-id="element-705">
                      <span data-id="element-706">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-707" />
                    </button>
                    <button className="border-2 border-[#214ae9] text-[#214ae9] px-6 py-3 rounded-lg font-bold hover:bg-[#214ae9] hover:text-white transition-all" data-id="element-708">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-709">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-710">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-711">
                      <ShieldIcon className="w-6 h-6 text-[#b063ff]" data-id="element-712" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-713">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-714">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-715">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-716">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-717" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-718">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-719">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 3: Cyan Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-720">
            <div className="bg-[#00f4f8] px-8 py-4 border-b border-cyan-300" data-id="element-721">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-722">
                Option 3: Cyan Primary
              </h2>
              <p className="text-sm text-[#111111] text-opacity-70" data-id="element-723">
                Fresh and innovative • High energy
              </p>
            </div>
            <div className="p-8" data-id="element-724">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-725">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-726">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-727">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-728">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-729">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-730">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-[#00d9dd] transition-all shadow-lg flex items-center space-x-2" data-id="element-731">
                      <span data-id="element-732">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-733" />
                    </button>
                    <button className="border-2 border-[#b063ff] text-[#b063ff] px-6 py-3 rounded-lg font-bold hover:bg-[#b063ff] hover:text-white transition-all" data-id="element-734">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-735">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-736">
                    <div className="w-12 h-12 bg-[#00f4f8] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-737">
                      <ShieldIcon className="w-6 h-6 text-[#00f4f8]" data-id="element-738" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-739">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-740">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-741">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-742">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-743" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-744">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-745">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 4: Balanced Trio */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-746">
            <div className="bg-gradient-to-r from-[#214ae9] via-[#b063ff] to-[#00f4f8] px-8 py-4" data-id="element-747">
              <h2 className="text-xl font-bold text-white" data-id="element-748">
                Option 4: Balanced Trio
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-749">
                Equal emphasis • Vibrant and dynamic
              </p>
            </div>
            <div className="p-8" data-id="element-750">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-751">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-752">
                  <div className="inline-block bg-white bg-opacity-10 text-white px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-white border-opacity-20" data-id="element-753">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-754">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-755">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-756">
                    <button className="bg-gradient-to-r from-[#214ae9] to-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:shadow-xl transition-all shadow-lg flex items-center space-x-2" data-id="element-757">
                      <span data-id="element-758">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-759" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-760">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-761">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-762">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-763">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-764" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-765">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-766">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-767">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-768">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-769" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-770">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-771">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 5: High Contrast */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-772">
            <div className="bg-[#111111] px-8 py-4 border-b border-gray-800" data-id="element-773">
              <h2 className="text-xl font-bold text-white" data-id="element-774">
                Option 5: High Contrast
              </h2>
              <p className="text-sm text-gray-400" data-id="element-775">
                Bold and striking • Maximum impact
              </p>
            </div>
            <div className="p-8" data-id="element-776">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-777">
                {/* Hero preview */}
                <div className="bg-[#111111] rounded-xl p-8 border-2 border-[#00f4f8]" data-id="element-778">
                  <div className="inline-block bg-[#00f4f8] text-[#111111] px-4 py-1.5 rounded-full text-sm font-bold mb-6" data-id="element-779">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-780">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-781">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-782">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-white transition-all shadow-lg flex items-center space-x-2" data-id="element-783">
                      <span data-id="element-784">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-785" />
                    </button>
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg" data-id="element-786">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-787">
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-788">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-789">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-790" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-791">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-792">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-793">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-794">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-795" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-796">
                      Easy to Use
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-797">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 6: Light & Airy */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-798">
            <div className="bg-white px-8 py-4 border-b-2 border-[#214ae9]" data-id="element-799">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-800">
                Option 6: Light & Airy
              </h2>
              <p className="text-sm text-gray-600" data-id="element-801">
                Minimal and clean • Approachable
              </p>
            </div>
            <div className="p-8" data-id="element-802">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-803">
                {/* Hero preview */}
                <div className="bg-white rounded-xl p-8 border-2 border-gray-200" data-id="element-804">
                  <div className="inline-block bg-[#214ae9] bg-opacity-5 text-[#214ae9] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#214ae9] border-opacity-20" data-id="element-805">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-[#111111] mb-4" data-id="element-806">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-807">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-808">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-md flex items-center space-x-2" data-id="element-809">
                      <span data-id="element-810">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-811" />
                    </button>
                    <button className="bg-white border-2 border-gray-300 text-[#111111] px-6 py-3 rounded-lg font-bold hover:border-[#214ae9] hover:text-[#214ae9] transition-all" data-id="element-812">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-813">
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#214ae9] transition-colors" data-id="element-814">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-815">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-816" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-817">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-818">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#b063ff] transition-colors" data-id="element-819">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-820">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-821" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-822">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-823">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}